import React from 'react';
import cn from 'classnames';
import RoundedButton from '../RoundedButton/RoundedButton';
import { ReactComponent as PlusIcon } from '../../../../resource/PlusIcon.svg';
import useCellClickHandlers from '../../hooks/useCellClickHandlers';
import styles from './AddTaskButton.module.scss';

const AddTaskButton = ({ className }) => {
  const { handleAddTaskBtnClick } = useCellClickHandlers();

  return (
    <RoundedButton
      onClick={handleAddTaskBtnClick}
      className={cn(styles.root, className)}
    >
      Создать <PlusIcon />
    </RoundedButton>
  );
};

export default AddTaskButton;
